/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default ({
  white,
  primaryMain,
}) => css`
  .welcome-box {
    background-color: ${white};
    margin-top: 5rem;
    padding: 18px 25px;
    border-top: 22px solid ${primaryMain};
    border-radius: 11px;
    border-bottom: 22px solid ${primaryMain};
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;

    .title {
      font-size: 29px;
      font-weight: bold;
      color: ${primaryMain};
    }

    .subtitle {
      padding-top: 5px;
      font-weight: bold;
      color: ${primaryMain};
    }

    .text {
      padding-top: 5px;
      padding-bottom: 12px;
    }
  }
`;
